import { DatePipe } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SepaMandate } from '../../models/sepa-mandates';

@Component({
  selector: 'lib-create-new-mandate-modal',
  standalone: false,
  templateUrl: './create-new-mandate-modal.component.html',
  styleUrl: './create-new-mandate-modal.component.scss'
})
export class CreateNewMandateModalComponent implements OnInit {
  public activeModal = inject(NgbActiveModal);
  protected formBuilder = inject(FormBuilder);
  protected datePipe = inject(DatePipe);

  sepaMandateForm: FormGroup;
  sepaMandate: SepaMandate;
  today = new Date();
  selectedFile: File | null = null;

  ngOnInit(): void {
    this.initForm();
  }
  
  initForm() {
    this.sepaMandateForm = this.formBuilder.group({
      id: this.sepaMandate?.id || null,
      customerErpId: this.formBuilder.control(this.sepaMandate?.customerErpId || ''),
      mandateId: this.formBuilder.control(this.sepaMandate?.mandateId || ''),
      mandateSignatureDate: this.formBuilder.control(this.sepaMandate?.mandateSignatureDate || ''),
      debtorIban: this.formBuilder.control(this.sepaMandate?.debtorIban || ''),
      debtorBic: this.formBuilder.control(this.sepaMandate?.debtorBic || '')
    });
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedFile = input.files[0];
    }
  }

  crossClick() {
    this.activeModal.dismiss('Cross click');
  }

  submitForm() {
    if (this.sepaMandateForm.invalid) {
      return;
    }

    const mandate: SepaMandate = this.sepaMandateForm.value;
    if (mandate.mandateSignatureDate) {
      mandate.mandateSignatureDate = this.datePipe.transform(mandate.mandateSignatureDate, 'yyyy-MM-dd');
    }

    this.activeModal.close({
      mandate,
      file: this.selectedFile
    });
  }
}
